import React, { ReactElement } from 'react'

function S(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect y="0.5" width="48" height="48" rx="6.85714" fill="url(#paint0_linear_36_17)"/>
    <g clipPath="url(#clip0_36_17)">
      <path d="M24 33.5C28.9706 33.5 33 29.4706 33 24.5C33 19.5294 28.9706 15.5 24 15.5C19.0294 15.5 15 19.5294 15 24.5C15 29.4706 19.0294 33.5 24 33.5Z" stroke="#3464E6" strokeWidth="2" strokeMiterlimit="10"/>
      <path d="M20.25 24.5H27.75" stroke="#3464E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24 20.75V28.25" stroke="#3464E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <linearGradient id="paint0_linear_36_17" x1="0" y1="0.5" x2="43.3973" y2="46.3064" gradientUnits="userSpaceOnUse">
        <stop stopColor="#E7EDFF"/>
        <stop offset="1" stopColor="#C6D5FF"/>
      </linearGradient>
      <clipPath id="clip0_36_17">
        <rect width="24" height="24" fill="white" transform="translate(12 12.5)"/>
      </clipPath>
    </defs>
  </svg>
}

export default S
